'use strict';

import React from 'react';

import DpsTable from '../components/DpsDataTableComponent'

require('styles//DpsObl.css');

class DpsOblComponent extends React.Component {
  constructor(props){
super(props);this.state = {sp:[],years:[],obls:[], pokas:[], group: '01',iddps:'0000',view:'0',year:'2000',area:'00', dataTable:[]};
    this.handleChange = this.handleChange.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
    var iddps= name=='iddps'?value:this.state.iddps;
    if(name=='group'){
        for(var i in this.state.sp){
           if(this.state.sp[i].group==value){
             this.setState({pokas: this.state.sp[i].pokas,iddps:this.state.sp[i].pokas[0].kod});
             iddps=this.state.sp[i].pokas[0].kod;
             break;
           }
        }
    }
    //console.log(`change state {${name}: ${value}} ${iddps}...`)
    //загрузка табличных данных
    if(this.state.view=='3' || (name=='view' && value=='3')){
      //console.log(`start loading dataTable ${iddps}...`)
      this.loadDataTable(iddps);
    }
  }
  loadDataTable(iddps){
    var self=this;
      this.loadJSON(function(response) {
        var my_data=JSON.parse(response);
        //console.log(`loaded data ${iddps} length=${my_data.length}`);
        self.setState({dataTable:my_data});
      },`http://${document.location.hostname}/Dps/DpsServlet?kod=${iddps}`);
  }
  componentDidMount() {
    var self=this;
    this.loadJSON(function(response) {
        //console.log(response);
        var my_data=JSON.parse(response);
        var years=[];
        for(var c=my_data.yearBeg;c<=my_data.yearEnd;c++){
            years.push(c);
        }
        self.setState({years:years,year: my_data.yearEnd, obls:my_data.obls, sp: my_data.sp, pokas: my_data.sp[0].pokas, group: my_data.sp[0].group,iddps:my_data.sp[0].pokas[0].kod});
    },'dpscodes.json');
}
loadJSON(callback,jsonfile){
  var xobj = new XMLHttpRequest();
  xobj.overrideMimeType('application/json');
  xobj.open('GET', jsonfile, true);
  xobj.onreadystatechange = function(){
    if(xobj.readyState == 4 && xobj.status == '200'){
      callback(xobj.responseText);
    }
  };
  xobj.send(null);
}
  render() {
    let subsel='';
    let capsup='';
    let srcImg='';
   // let dataTable='';
    if(this.state.view=='0'){
    capsup=<b>Период:</b>
      srcImg= `https://${document.location.hostname}/Dps/map?width=820&id_pokaz=${this.state.iddps}&year=${this.state.year}`
      subsel=<select name="year" value={this.state.year} onChange={this.handleChange}>{this.state.years.map((row, index) =><option key={index} value={row}>{row}</option>)}</select>
    }
    if(this.state.view=='1'){
      capsup=<b>Период:</b>
      srcImg=`https://${document.location.hostname}/Dps/chart?width=820&id_pokaz=${this.state.iddps}&year=${this.state.year}`
      subsel=<select name="year" value={this.state.year} onChange={this.handleChange}>{this.state.years.map((row, index) =><option key={index} value={row}>{row}</option>)}</select>
}else if(this.state.view=='2'){
capsup=<b>Период:</b>
srcImg=`https://${document.location.hostname}/Dps/chart?width=820&id_pokaz=${this.state.iddps}&i_area=${this.state.area}`
subsel=<select name="area" value={this.state.area} onChange={this.handleChange}>{this.state.obls.map((row, index) =><option key={index} value={row.kod}>{row.name}</option>)}</select>
}/*else if(this.state.view=='3'){
    dataTable=<table className="dataTable"><tbody><tr key="header"><th>Область</th>{this.state.years.map((row,index)=><th key={index}>{row}</th>)}</tr>
    {this.state.obls.map((row,i)=>this.getDataRow(row,i))}</tbody></table>
}*/
    return (
      <div className="dpsobl-component">
        <form>
<table><tbody><tr><td><b>Группа:</b></td><td colSpan="5">
<select name="group" value={this.state.group} onChange={this.handleChange}>
{this.state.sp.map((row, index) =><option key={index} value={row.group}>{row.name}</option>)}
</select></td></tr>
<tr><td><b>Показатель:</b></td><td colSpan="5"><select name="iddps" value={this.state.iddps} onChange={this.handleChange}>
{this.state.pokas.map((row, index) =><option key={index} value={row.kod}>{row.name}</option>)}</select></td></tr>
<tr><td><b>Просмотр:</b></td><td>
<select name="view" value={this.state.view} onChange={this.handleChange}><option value="0">Карта</option><option value="1">Диаграмма (Области)</option><option value="2">Диаграмма (Периоды)</option><option value="3">Таблица</option></select></td><td className="capAlign">{capsup}</td><td>{subsel}</td></tr>
<tr><td colSpan="6">{this.state.view=='3'?<center><DpsTable iddps={this.state.iddps} dataTable={this.state.dataTable} years={this.state.years}/></center>:<center><img alt="Показатели на карте"  src={srcImg}/></center>}</td></tr></tbody></table></form>
</div>
    );
  }
}

DpsOblComponent.displayName = 'DpsOblComponent';

// Uncomment properties you need
// DpsOblComponent.propTypes = {};
// DpsOblComponent.defaultProps = {};

export default DpsOblComponent;



// WEBPACK FOOTER //
// ./src/components/DpsOblComponent.js